import { motion } from "framer-motion";

/**
 * Hanging café pendant lamp for the auth modal.
 * on: bulb lit? mood: "idle" | "error" (flicker) | "success" (bright pulse)
 * pulse: bump to replay the ignition flicker. onToggle: click the shade.
 */
export const LampLight = ({ on, mood = "idle", pulse = 0, onToggle }) => (
  <div className="relative flex justify-center h-[108px] mb-1" data-testid="auth-lamp">
    <motion.div
      className="relative w-28 h-full"
      style={{ transformOrigin: "50% 0%" }}
      animate={{ rotate: [-2.5, 2.5, -2.5] }}
      transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut" }}
    >
      <div className="absolute left-1/2 -translate-x-1/2 top-0 w-3 h-3 rounded-full bg-[#1C130E]/80" />
      <div className="absolute left-1/2 -translate-x-1/2 top-2 w-px h-10 bg-[#1C130E]/40" />
      <button
        type="button"
        onClick={onToggle}
        data-testid="auth-lamp-toggle"
        aria-label={on ? "Turn lamp off" : "Turn lamp on"}
        className="absolute left-1/2 -translate-x-1/2 top-[46px] w-16 h-9 rounded-t-[999px] bg-[#1C130E] cursor-pointer transition-transform duration-200 hover:scale-[1.05] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C85A32]/60"
      >
        <span className={`absolute left-1/2 -translate-x-1/2 bottom-0 w-10 h-1.5 rounded-full transition-colors duration-300 ${on ? "bg-[#C85A32]" : "bg-[#1C130E]/50"}`} />
      </button>
      <div className="absolute left-1/2 -translate-x-1/2 top-[64px]">
        {on && (
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-44 h-44 pointer-events-none">
            <motion.div
              key={`${pulse}-${mood}`}
              className="w-full h-full rounded-full"
              style={{
                background:
                  "radial-gradient(circle, rgba(200,90,50,0.35) 0%, rgba(200,90,50,0.12) 45%, transparent 70%)",
              }}
              initial={{ opacity: [0, 0.9, 0.25, 1], scale: 1 }}
              animate={
                mood === "error"
                  ? { opacity: [1, 0.12, 1, 0.25, 1], scale: 1 }
                  : mood === "success"
                    ? { opacity: 1, scale: [1, 1.22, 1.06] }
                    : { opacity: 1, scale: 1 }
              }
              transition={
                mood === "error"
                  ? { duration: 0.55 }
                  : mood === "success"
                    ? { duration: 0.9 }
                    : { duration: 0.35 }
              }
            />
          </div>
        )}
        <motion.div
          className={`relative w-7 h-9 rounded-full transition-colors duration-300 ${
            on ? "bg-[#FFD9A0] shadow-[0_0_18px_6px_rgba(232,146,74,0.55)]" : "bg-[#EAE2D3]"
          }`}
          animate={mood === "success" ? { scale: [1, 1.12, 1] } : { scale: 1 }}
          transition={{ duration: 0.9 }}
        />
        <div className={`mx-auto -mt-1 w-3.5 h-2 rounded-b-md transition-colors duration-300 ${on ? "bg-[#C85A32]" : "bg-[#1C130E]/40"}`} />
      </div>
    </motion.div>
  </div>
);